export default {"src":"/_next/static/media/interpreter.ea81212b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};